// Global JS
// --

// Navigation "active" toggle
const currentPathName = location.pathname;
$(".navbar-custom li a").each(function () {
  const $this = $(this);
  if ($this.attr("href") === currentPathName) {
    $this.parent().addClass("active");
  }
});

// Tooltips - Initialize all
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

// Disable autocomplete and paste in all input and textarea fields
document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('input, textarea');
  console.log("here");

  inputs.forEach(input => {
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('paste', function (e) {
      e.preventDefault();
    });
  });
});